import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BalanceState } from './balance.reducer';
import * as fromBalance from './balance.reducer';
import { BalanceQuery } from './balance.actions';
import { LoadingState, getError } from 'app/utils/callstate';
import { sortBy } from 'lodash';

export const selectBalanceState = createFeatureSelector<BalanceState>('balance');

export const selectBalance = createSelector(
  selectBalanceState,
  fromBalance.selectAll
);
export const selectBalanceSorted = createSelector(
  selectBalance,
  balance => sortBy(balance, 'account')
);

export const selectBalanceLoading = createSelector(
  selectBalanceState,
  balanceState => balanceState.callState === LoadingState.Loading
);

export const selectBalanceLoaded = createSelector(
  selectBalanceState,
  balanceState => balanceState.callState === LoadingState.Loaded
);

export const selectBalanceError = createSelector(
  selectBalanceState,
  balanceState => getError(balanceState.callState)
);

export const selectBalanceQuery = createSelector(
  selectBalanceState,
  balanceState => ({
    companyId: balanceState.companyId,
    key: balanceState.key,
    filter: balanceState.filter
  } as BalanceQuery)
);
